// Module
var code = "<p>בקלות רבה. לאחר שהתחברתם לאתר, תוכלו ללחוץ על לחצן החשבון שבחלקו העליון של עמוד הבית ולבחור בניהול נכסים. לחצו על לחצן העריכה ומשם הדרך כבר קצרה :) אל תשכחו לשמור את השינויים על ידי לחצן העדכון נכס שבתחתית העמוד.</p> ";
// Exports
export default code;